import styled from 'styled-components'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-x: auto;
  position: relative;
  overscroll-behavior-x: none;
  /* Same rounding as the Sidebar shell card. overflow-x makes this a clipping
     box, so the radius also rounds off whatever reaches the corners — on
     desktop nothing does (PLAY_HEAD_WRAPPER_PADDING insets the playhead 20px,
     clear of the 16px arc). */
  border-radius: 16px;

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    /* The panel is full-bleed and square below this breakpoint (see
       TimelineContainer), and the playhead's inset halves to 10px — inside the
       arc — so keeping the radius here curved the bottom of the playhead line
       away. Follow the panel: no rounding, no clipped playhead. */
    border-radius: 0;
  }
`

export const ContentWrapper = styled.div`
  width: min-content;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
`

export const StickyContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: white;
`
